import {Component} from '@angular/core';
import {RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterEvent} from "@angular/router";
import {AlertService} from "./services/alert/alert.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bKash';

  constructor(private router: Router,private alert:AlertService) {
    router.events.subscribe((event: RouterEvent) => {

      //lazyloading start
      if(event instanceof RouteConfigLoadStart) {
        this.alert.loading()
      }
      //lazy loading end
      else if(event instanceof RouteConfigLoadEnd) {
        this.alert.closeAlert()
      }
    })
  }

}
